module.exports = __webpack_public_path__ + "static/media/oculushealth.b0cc92a7.png";